import React, { useEffect, useState } from "react";
import errorLogo from "../../assets/images/error.svg";
import { mykBranding } from "../../assets/images";
import PrimaryButtons from "../CommonComponent/Button/primaryButton";
import './unauthorized.scss';

const UnAthorized = () => {
	const [email, setEmail] = useState('');
	const [cdnBaseUrl, setcdnBaseUrl] = useState('');

	useEffect(() => {
		fetch('/auth/GetBlobCDNURL')
			.then(async (response) => await response.json())
			.then((json) => {		
				setcdnBaseUrl(json.containerCDNURL);
				setEmail(json.userEmail);
		})
	}, []);

	const SignOut = () => {	
		window.location.href = "/auth/logout";		
	};

	return (
		<div className="main-wrapper error">
			<div className="content-wrapper">
				<div className="title">
					<img src={cdnBaseUrl + mykBranding} alt="logo" className="Error logoImg" />
					<div className="error-container">
						<img src={errorLogo} alt="error" />
						<div className="error-value">401</div>
					</div>
					<div className="error-message">
						UnAuthorized User
					</div>
					<div className="error-discription">OOPS! You ({email}) are not authorized to view this page.
						Please contact the administrator for more details.
					</div>
					<div className="error-btn">
						<PrimaryButtons text="Signout" onClick={SignOut}/>
					</div>
				</div>
			</div>
		</div>
	)

}

export default UnAthorized
